module.exports = __webpack_public_path__ + "static/media/Manuale.505e7dac.pdf";